// extracted by mini-css-extract-plugin
export default {"badge":"BadgeWithTooltip_badge__MzdOJ"};